import _Set from "@babel/runtime-corejs3/core-js-stable/set";
var SUPPORTED_HTML_ELEMENTS = new _Set(["a", "br", "code", "h1", "h2", "h3", "h4", "h5", "h6", "hr", "label", "iframe", "i", "p", "b", "img", "image", "pre", "span", "div"]);
export var isSupportedHTMLElement = function isSupportedHTMLElement(component) {
  return SUPPORTED_HTML_ELEMENTS.has(component);
};